import { AiOutlineWarning } from 'react-icons/ai';
import { IoMdClose } from 'react-icons/io';
import { IoSquareOutline } from 'react-icons/io5';
import classNames from '@/lib/misc/classNames';
interface Props {
  message: string;
  hideWarning?: () => void;
  onClose?: () => void;
  className?: string;
}
const WarningMessage = (p: Props) => {
  return <div className={classNames('relative flex flex-col gap-1.5 bg-[#F87171] px-6 pt-4 pb-5 rounded-xl text-genius-indigo font-medium leading-[80%] tracking-[-0.3px]', p.className)} data-sentry-component="WarningMessage" data-sentry-source-file="WarningMessage.tsx">
      {p.onClose ? <IoMdClose size={15} className='absolute top-3 right-3' onClick={p.onClose} /> : null}
      <div className='flex items-center gap-2'>
        <AiOutlineWarning size={24} data-sentry-element="AiOutlineWarning" data-sentry-source-file="WarningMessage.tsx" />
        <div className='text-[16px]'>Risk Warning</div>
      </div>
      <div className='text-[10.5px]'>{p.message}</div>
      {p.hideWarning ? <div className='flex items-center gap-1.5 mt-1' onClick={p.hideWarning}>
          <IoSquareOutline size={14} />
          <div className='text-[10.5px]'>
            I understand the risks, don’t show me this message again
          </div>
        </div> : null}
    </div>;
};
export default WarningMessage;